import { getRestaurants, addRestaurant, editRestaurant, deleteRestaurant } from '../../config/config'
import globalActions from './GlobalActions'
import localforage from 'localforage'

import { toast } from '../../utils/toast'
import { parseError } from '../../utils/parseError'
import { LOGOUT_USER, SET_PERMISSIONS, SET_PERMISSIONS_OPERATION } from './AuthActions'
import { handleError } from '../../utils/utils'
import {
  ADMIN_PERMISSION_SECTION,
  OPERATION_PERMISSION_SECTION,
  getRestaurantPermissions,
  parseRestaurantPermissionPayload,
  resolvePostLoginPath,
  shouldRedirectPostLogin,
} from '../../utils/restaurantPermissions'

import { setTabRestaurant } from '../../utils/tabRestaurant'
export const GET_REST_REQUEST = 'GET_REST_REQUEST'
export const GET_REST_SUCCESS = 'GET_REST_SUCCESS'
export const GET_REST_ERROR = 'GET_REST_ERROR'

export const ADD_REST_STARTED = 'ADD_REST_STARTED'
export const ADD_REST_END = 'ADD_REST_END'

export const EDIT_REST_STARTED = 'EDIT_REST_STARTED'
export const EDIT_REST_END = 'EDIT_REST_END'

export const DELETE_REST_STARTED = 'DELETE_REST_STARTED'
export const DELETE_REST_END = 'DELETE_REST_END'

export const SET_REST = 'SET_REST'
export const SET_REST_DATA = 'SET_REST_DATA'
export const SET_MODULES = 'SET_MODULES'
export const CLEAR_ALL_REST = 'CLEAR_ALL_REST'

export const ALL_RESTAURANTS_ROLES = 'ALL_RESTAURANTS_ROLES'
export const ALL_RESTAURANTS_ROLES_OPERATION = 'ALL_RESTAURANTS_ROLES_OPERATION'

export const CLEAR_RESTAURANTS_LOADING = 'CLEAR_RESTAURANTS_LOADING'

const actions = {
  setSelectedRestData: (data) => (dispatch) => {
    dispatch({
      type: SET_REST_DATA,
      payload: data
    })
  },
  // Get All restaurants with the selected one
  getRest: (selected, getBranches, setBlockGetBranches, history) => async (dispatch, getState) => {
    setBlockGetBranches(true)
    dispatch({
      type: GET_REST_REQUEST,
    })
    await getRestaurants().then((res) => {
      if (res?.status === 200) {
        dispatch({
          type: GET_REST_SUCCESS,
          payload: {
            restaurants: res?.data?.restaurants,
            availableSections: res?.data?.availableSections,
            ...parseRestaurantPermissionPayload(res?.data),
          },
        })
        dispatch({
          type: SET_MODULES,
          payload: res?.data?.modules
        })
        if (res?.data?.restaurants?.length === 0) {
          dispatch({
            type: SET_REST,
            payload: { selected: '' },
          })
        }
        let temp = []
        if (res?.data?.restaurants?.length > 0) {
          temp = res.data.restaurants.map((rest) => { return rest.uuid })
          dispatch({
            type: SET_REST,
            payload: { selected: temp.includes(selected) ? selected : res.data.restaurants[0]?.uuid },
          })
        }
        const selectedUuid = temp.includes(selected) ? selected : res?.data?.restaurants?.[0]?.uuid
        setTabRestaurant(selectedUuid)
        getBranches(selectedUuid)
        const { permissionTrees, restaurantAccess } = parseRestaurantPermissionPayload(res?.data)
        const selectedRestaurantPermission = getRestaurantPermissions(
          permissionTrees,
          restaurantAccess,
          getState().rest.selectedRest,
          ADMIN_PERMISSION_SECTION
        )
        const selectedRestaurantPermissionOperation = getRestaurantPermissions(
          permissionTrees,
          restaurantAccess,
          getState().rest.selectedRest,
          OPERATION_PERMISSION_SECTION
        )
        dispatch({
          type: SET_PERMISSIONS,
          payload: Array.isArray(selectedRestaurantPermission) ? selectedRestaurantPermission : [],
        })
        dispatch({
          type: SET_PERMISSIONS_OPERATION,
          payload: Array.isArray(selectedRestaurantPermissionOperation) ? selectedRestaurantPermissionOperation : [],
        })
        if (
          shouldRedirectPostLogin(
            history.location.pathname,
            selectedRestaurantPermission,
            selectedRestaurantPermissionOperation,
            permissionTrees,
            restaurantAccess,
            selectedUuid
          )
        ) {
          const target = resolvePostLoginPath(
            selectedRestaurantPermission,
            selectedRestaurantPermissionOperation
          )
          if (target) history.push(target)
        }
        if (selectedRestaurantPermission?.length === 0 && selectedRestaurantPermissionOperation?.length === 0) {
          localforage.dropInstance().then(function () {
          }).catch(function (err) {
            console.error('Error deleting database:', err);
          });
          toast.error('No accessible permissions for this restaurant.')
        }
      } else {
        handleError(dispatch)(res, GET_REST_ERROR, 'GET RESTAURANT ERROR')
        // if (res.status !== 401 && res.status !== 403)
        //   toast.error(res?.data?.message || 'Get All Restaurant error')
        // if (res.status === 401) {
        //   dispatch({ type: LOGOUT_USER })
        // }
        // if (res.status === 403) {
        //   window.location = '/forbidden'
        //   dispatch({
        //     type: SET_PERMISSIONS,
        //     payload: res?.data?.permissions
        //   })
        // }
        // dispatch({
        //   type: GET_REST_ERROR,
        //   payload: {
        //     message: parseError(res?.data?.error) || res?.data?.message || 'GET REST error',
        //   },
        // })
      }
    })
    setBlockGetBranches(false)
  },

  addRestaurant: (data) => async (dispatch) => {
    dispatch({
      type: ADD_REST_STARTED,
    })
    await addRestaurant(data).then((res) => {
      if (res?.status === 200) {
        toast.success(res?.data?.message || 'Successfully Saved!')
        dispatch({
          type: GET_REST_SUCCESS,
          payload: {
            restaurants: res?.data?.restaurants,
            availableSections: res?.data?.availableSections,
          },
        })
        if (res?.data?.restaurants?.length === 0) {
          dispatch({
            type: SET_REST,
            payload: { selected: '' },
          })
        }
        if (res?.data?.restaurants?.length === 1) {
          dispatch({
            type: SET_REST,
            payload: { selected: res?.data?.restaurants[0]?.uuid },
          })
        }
      } else {
        handleError(dispatch)(res, null, 'ADD RESTAURANT ERROR')
        // if (res.status !== 401 && res.status !== 403)
        //   toast.error(res?.data?.message || 'Add Restaurant error')
        // if (res.status === 401) {
        //   dispatch({ type: LOGOUT_USER })
        // }
        // if (res.status === 403) {
        //   window.location = '/forbidden'
        //   dispatch({
        //     type: SET_PERMISSIONS,
        //     payload: res?.data?.permissions
        //   })
        // }
      }
    })
    dispatch({
      type: ADD_REST_END,
    })
  },

  editRestaurant: (data, uuid, history) => async (dispatch) => {
    dispatch({
      type: EDIT_REST_STARTED,
    })
    await editRestaurant(data, uuid).then((res) => {
      if (res?.status === 200) {
        toast.success(res?.data?.message || 'Successfully Saved!')
        dispatch({
          type: GET_REST_SUCCESS,
          payload: {
            restaurants: res?.data?.restaurants,
            availableSections: res?.data?.availableSections,
          },
        })
        if (res?.data?.restaurants?.length === 0) {
          dispatch({
            type: SET_REST,
            payload: { selected: '' },
          })
        }
        if (res?.data?.restaurants?.length === 1) {
          dispatch({
            type: SET_REST,
            payload: { selected: res?.data?.restaurants[0]?.uuid },
          })
        }
      } else {
        handleError(dispatch)(res, null, 'EDIT RESTAURANT ERROR')
        // if (res.status !== 401 && res.status !== 403)
        //   toast.error(res?.data?.message || 'Edit Restaurant error')
        // if (res.status === 401) {
        //   dispatch({ type: LOGOUT_USER })
        // }
        // if (res.status === 403) {
        //   window.location = '/forbidden'
        //   dispatch({
        //     type: SET_PERMISSIONS,
        //     payload: res?.data?.permissions
        //   })
        // }
      }
    })
    dispatch({
      type: EDIT_REST_END,
    })
  },

  deleteRestaurant: (uuid, history) => async (dispatch) => {
    dispatch({
      type: DELETE_REST_STARTED,
    })
    await deleteRestaurant(uuid).then((res) => {
      if (res?.status === 200) {
        dispatch({
          type: GET_REST_SUCCESS,
          payload: {
            restaurants: res?.data?.restaurants,
            availableSections: res?.data?.availableSections,
          },
        })
        if (res?.data?.restaurants?.length === 0) {
          dispatch({
            type: SET_REST,
            payload: { selected: '' },
          })
        }
        if (res?.data?.restaurants?.length === 1) {
          dispatch({
            type: SET_REST,
            payload: { selected: res?.data?.restaurants[0]?.uuid },
          })
        }
        if (res?.data?.restaurants?.length > 1) {
          dispatch({
            type: SET_REST,
            payload: { selected: res?.data?.restaurants[0]?.uuid },
          })
        }
        history.push('/add-restaurant')
      } else {
        handleError(dispatch)(res, null, 'DELETE RESTAURANT ERROR')
        // if (res.status !== 401 && res.status !== 403)
        //   toast.error(res?.data?.message || 'Delete Restaurant error')
        // if (res.status === 401) {
        //   dispatch({ type: LOGOUT_USER })
        // }
        // if (res.status === 403) {
        //   window.location = '/forbidden'
        //   dispatch({
        //     type: SET_PERMISSIONS,
        //     payload: res?.data?.permissions
        //   })
        // }
      }
    })
    dispatch({
      type: DELETE_REST_END,
    })
  },

  // SET Selected Restaurant
  setSelectedRest: (value) => (dispatch, getState) => {
    setTabRestaurant(value)
    // Re-picking the restaurant that is already selected must be a no-op: clearAllData() wipes the
    // branch slice, but App.js only refetches branches when `rest.selectedRest` *changes*, so the
    // page was left with no branches and pages gated on them (Self Ordering) made no API calls
    // until a full refresh.
    if (value && value === getState().rest.selectedRest) return
    dispatch(globalActions.clearAllData())
    dispatch({
      type: SET_REST,
      payload: { selected: value },
    })
    const { permissionTrees, restaurantAccess } = getState().rest
    const selectedRestaurantPermission = getRestaurantPermissions(
      permissionTrees,
      restaurantAccess,
      value,
      ADMIN_PERMISSION_SECTION
    )
    const selectedRestaurantPermissionOperation = getRestaurantPermissions(
      permissionTrees,
      restaurantAccess,
      value,
      OPERATION_PERMISSION_SECTION
    )
    dispatch({
      type: SET_PERMISSIONS,
      payload: selectedRestaurantPermission,
    })
    dispatch({
      type: SET_PERMISSIONS_OPERATION,
      payload: selectedRestaurantPermissionOperation,
    })
    if (!selectedRestaurantPermission.length && !selectedRestaurantPermissionOperation.length) {
      localStorage.clear()
      toast.error('No accessible permissions for selected restaurant.')
    }
  },

  resetDeleteLoading: () => (dispatch) => {
    dispatch({
      type: DELETE_REST_END,
    })
  },

  // CLEAR ALL Reducer
  clearAll: () => (dispatch) => {
    dispatch({
      type: CLEAR_ALL_REST,
    })
  },
}

export default actions
